import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { EquipmentService } from '../../../../services/equipment/equipment.service';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { EquipmentRecordComponent } from '../equipment-record/equipment-record.component';
import { environment } from '../../../../../environments/environment';
import { HttpRequestService } from '../../../../utilities/http/request.utilities';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator'; 
import { BehaviorSubject, of } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [MatCardModule, MatTableModule, MatIconModule, MatProgressSpinnerModule, CommonModule, FormsModule, MatSelectModule, MatFormFieldModule, MatOptionModule, MatPaginatorModule, MatSortModule,MatAutocompleteModule, MatInputModule, MatPaginator,NgxMatSelectSearchModule ,ReactiveFormsModule,],
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})

export class StatisticsComponent {

  public selectManual: string = ''; 
  public makes: string[] = [];
  public manualTypes: string[] = [];
  public isMakeLoading: boolean = false;

  public selectedModelDisplay: string = '';

  public filteredMakes: string[] = [];
  public filteredManualTypes: string[] = [];

  public makeFilterCtrl = new FormControl('');
  public manualTypeFilterCtrl = new FormControl('');
  
  public makeOptionsStatus = {
    label: of('Select Make'),
    enabled: new BehaviorSubject(false), 
    filteredData: new BehaviorSubject<string[]>([])
  };

  public manualTypeOptionsStatus = {
    label: of('Select Manual Type'),
    enabled: of(true),
    filteredData: new BehaviorSubject<string[]>([])
  };
  
  displayedColumns: string[] = ['make','PDFLinkedFlags', 'equipmentCost', 'percentageOfTotalOEC', 'distinctEquipmentCodeCount', 'percentageOfTotalCount'];
  public dataSource = new MatTableDataSource<any>();
  public totalByModelDataSourceDS = new MatTableDataSource<any>();


  public pageSize = 5;
  public currentPage = 0;
  public totalMakes = 0;
  public isLoadingMakes: boolean = false;
  public noResultsForMake: boolean = false;

  totalByModelDisplayedColumns: string[] = ['make', 'model', 'distinctEquipmentCodeCount', 'equipmentCost'];
  totalByModelDataSource: any = {};
  isLoadingTotalByModel: boolean = false;

  detailedModelDisplayedColumns: string[] = ['model', 'manualType', 'distinctEquipmentCodeCount', 'equipmentCost'];
  detailedModelDataSource = new MatTableDataSource<any>();
  isLoadingDetailedModel: boolean = false;

  selectedMake: string = '';
  selectedFlag: string = '';
  selectedModel: string = '';
  selectedModel_gen : string = '';
  modelManual: string = '';
  selectedManualType: string = '';

  @ViewChild('mainSort') mainSort!: MatSort;
  @ViewChild('modelSort') modelSort!: MatSort;
  @ViewChild('detailSort') detailSort!: MatSort;
  @ViewChild('modelPaginator') modelPaginator!: MatPaginator;
  @ViewChild('detailPaginator') detailPaginator!: MatPaginator;

  constructor(private changeDetectorRefs: ChangeDetectorRef, private dialog: MatDialog, private equipmentService: EquipmentService, private httpRequestService: HttpRequestService) {}

  ngAfterViewInit(): void {
    this.dataSource.sort = this.mainSort;

    if (this.totalByModelDataSource instanceof MatTableDataSource) {
      this.totalByModelDataSource.sort = this.modelSort;
      this.totalByModelDataSource.paginator = this.modelPaginator;
    }

    if (this.detailedModelDataSource instanceof MatTableDataSource) {
      this.detailedModelDataSource.sort = this.detailSort;
      this.detailedModelDataSource.paginator = this.detailPaginator;
    }
  }


  ngOnInit(): void {
    this.equipmentService.fetchAllMakes().then(data => {
      this.makes = data.makes;
      this.filteredMakes = [...this.makes];
      
      this.makeFilterCtrl.valueChanges.subscribe((search: string | null) => {
      const value = search?.toLowerCase() || '';
      this.filteredMakes = this.makes.filter(make =>
        make.toLowerCase().includes(value)
      );
    });
  });
   
    this.fetchManualTypes();

    this.manualTypeFilterCtrl.valueChanges.subscribe((search: string | null) => {
      const value = search?.toLowerCase() || '';
      this.filteredManualTypes = this.manualTypes.filter(type =>
        type.toLowerCase().includes(value)
      );
    });


  }

  public handleSelectMake(make: string): void {
    this.selectedMake = make;
    //reset next boards
    this.totalByModelDataSourceDS = new MatTableDataSource<any>([]);
    this.detailedModelDataSource = new MatTableDataSource<any>([]);
    this.selectedFlag = '';
    this.selectedModel = '';
    this.isLoadingTotalByModel = false;
    this.isLoadingDetailedModel = false;
    this.fetchMakes();
  }

  public fetchMakes(event?: PageEvent): void {
    this.dataSource = new MatTableDataSource<any>();
    this.currentPage = event ? event.pageIndex : this.currentPage;
    this.pageSize = event ? event.pageSize : this.pageSize;
    this.totalByModelDataSourceDS = new MatTableDataSource<any>([]);
    this.detailedModelDataSource = new MatTableDataSource<any>([]);
    this.selectedFlag = '';
    this.selectedModel = '';
    this.isLoadingTotalByModel = false;
    this.isLoadingDetailedModel = false;
    
    const selectedMake = this.selectedMake ? this.selectedMake : undefined;
    if (!this.selectedManualType) {
      return;
    }
    this.isLoadingMakes = true;
    
    this.equipmentService.getMakesStatistics(
      this.currentPage * this.pageSize,
      (this.currentPage + 1) * this.pageSize,
      selectedMake,
      encodeURIComponent(this.selectedManualType)
    )
    .then(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.mainSort; 
      this.totalMakes = selectedMake ? 1 : this.equipmentService.getMakes().length;
    })
    .catch(error => {
      this.dataSource = new MatTableDataSource<any>();
      this.dataSource.sort = this.mainSort;
      console.error("Error fetching makes statistics:", error);
    })
    .finally(() => {
      this.isLoadingMakes = false;
      this.changeDetectorRefs.detectChanges();
    });
  }
   public fetchManualTypes(): void {
    const url = environment.integrations.adminManualType; 
    this.httpRequestService.request<any>('GET', url).subscribe({
      next: (response) => {
        this.manualTypes = response.manual_types || response.data || response || [];
        this.filteredManualTypes = [...this.manualTypes];
        this.changeDetectorRefs.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching manual types:', error);
        // Use hardcoded values if API fails
        this.manualTypes = ['Service Manual', 'Operation Manual', 'Parts Manual', 'Operation & Maintenance Manual'];
        this.changeDetectorRefs.detectChanges();
      }
    });
  }
  public handleFlags(flag: string, make: string): void {
    //reset next board
    this.detailedModelDataSource = new MatTableDataSource<any>([]);
    this.selectedModel = '';
    this.isLoadingDetailedModel = false;
    this.fetchTotalByModelData(make, flag);
  }

  public handleModel(make: string, model: string, model_gen:string, model_manual:string): void {
    this.fetchDetailedModelData(make, model, model_gen);
    this.modelManual = model_manual || model; // Use model_manual if available, otherwise use model from eqp
  }

  private fetchTotalByModelData(make: string, flag: string): void {
    this.selectedFlag = flag;
    this.isLoadingTotalByModel = true;
    
    const url = `${environment.integrations.statistics.makemodels}?make=${make}&manual_type=${encodeURIComponent(this.selectedManualType)}`;

    this.httpRequestService.request<any>('GET', url).subscribe({
      next: (response) => {
        const models = (response.models || [])
          .filter((model: any) => model.status === flag)
          .map((model: any) => ({
            make: response.make,
            model: model.model, 
            model_gen: model.model_gen,
            model_manual: model.model_manual, 
            distinctEquipmentCodeCount: model.distinctEquipmentCodeCount,
            equipmentCost: model.equipmentCost
          }));

        this.totalByModelDataSourceDS = new MatTableDataSource(models);
        this.totalByModelDataSourceDS.sort = this.modelSort;
        this.totalByModelDataSourceDS.paginator = this.modelPaginator;
        this.isLoadingTotalByModel = false;
        this.changeDetectorRefs.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching aggregated data by model:', error);
        this.totalByModelDataSourceDS = new MatTableDataSource<any>([]);
        this.isLoadingTotalByModel = false;
        this.changeDetectorRefs.detectChanges();
      }
    });
  }

  private fetchDetailedModelData(make: string, model: string, model_gen:string) {
    this.selectedModel = model.trim(); // is this trim needed?
    this.selectedModelDisplay = '';
    this.selectedModel_gen = model_gen; 
    if (make === 'Skyjack') {
      make = 'SKYJACK';
    }
    this.isLoadingDetailedModel = true;

    const url = `${environment.integrations.statistics.models}?make=${make}&model=${encodeURIComponent(this.selectedModel)}&model_gen=${encodeURIComponent(this.selectedModel_gen)}&manual_type=${encodeURIComponent(this.selectedManualType)}`;

    this.httpRequestService.request<any>('GET', url).subscribe({
      next: (response) => {
      const firstModel = (response.equipments || [])[0]?.model;
      this.selectedModelDisplay = firstModel || this.selectedModel;
        const equipmentItems = (response.equipments || [])
        .filter((eq: any) => eq.status === this.selectedFlag)
        .map((eq: any) => ({
          id: eq.id,
          equipmentCode: eq.equipment_code,
          serialNumber: eq.serial_number,
          make: eq.make,
          model: eq.model,
          model_gen: eq.model_gen,
          cost: eq.equipment_cost_amt,
          status: eq.status
        }));

        this.detailedModelDataSource = new MatTableDataSource(equipmentItems);
        this.detailedModelDataSource.sort = this.detailSort;
        this.detailedModelDataSource.paginator = this.detailPaginator;

        this.selectedMake = response.make;
        this.isLoadingDetailedModel = false;
        this.changeDetectorRefs.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching detailed model data:', error);
        this.detailedModelDataSource = new MatTableDataSource<any>([]);
        this.isLoadingDetailedModel = false;
        this.changeDetectorRefs.detectChanges();
      }
    });
  }

openUploadModal(): void {
  if (this.selectedMake === 'Skyjack') {
    this.selectedMake = 'SKYJACK';
  }
  const modelParam = this.selectedModelDisplay; // eqp model 
  // //this.modelManual // manual model, corresponding to current equipment

  const endpoint = `${environment.integrations.adminResources}?make=${this.selectedMake}&model=${encodeURIComponent(modelParam)}`;

  this.httpRequestService.request<any>('GET', endpoint).subscribe({
    next: (response) => {
      // console.log('Resource Data:', response);
      const matchedItem = (response.items || []).filter(
        (item: any) =>
         item.MAKE === this.selectedMake &&
         item.Models === modelParam
      );
      // console.log('Matched Item:', matchedItem);
      let relatedCombinations: any[] = [];

      if (matchedItem) {
      relatedCombinations = (matchedItem).map((item: any) => {
      const validManuals = (item.Manuals || []).filter(
        (manual: any) =>
          manual.url &&
          manual.url !== null &&
          manual.url !== "" && 
          manual.url.endsWith('.pdf') &&
          !['Manual not available for Model', 'Manual not available for SN'].includes(manual.url)
      );

      return {
        make: item.MAKE || 'N/A',
        model: item.Models || 'N/A',
        startSerial: item.StartSerial || 'All',
        endSerial: item.EndSerial || 'All',
        pvc: item.PVC || 'N/A',
        title: validManuals[0]?.title || 'N/A',
        pdf_link: validManuals.map((m: any) => ({
          ...m,
          title: m.title || 'N/A'
        })),
        prompts: Array.isArray(item.PROMPTS?.resources)
          ? item.PROMPTS.resources.map((p: any) => p.prompt)
          : []
      };
    });
    }
    else {
        // fallback: dummy empty card
        relatedCombinations = [{
          make: this.selectedMake,
          model: modelParam,
          startSerial: 'N/A',
          endSerial: 'N/A',
          pvc: 'N/A',
          title: 'No manual available',
          pdf_link: [],
          prompts: []
        }];
      }

      this.dialog.open(EquipmentRecordComponent, {
        width: '300px',
        height: '800px',
        data: {
          make:  this.selectedMake,
          model:  modelParam,
          relatedCombinations,
          source: 'statistics',
        }
      });

    },
    error: (err) => {
      console.error('Error fetching resource data:', err);
      alert('Failed to fetch resource data.');
    }
  });
  
}

  onMakeChange(): void {
    this.handleSelectMake(this.selectedMake);
  }

 onManualTypeSelected(type: string): void {
  this.selectedManualType = type;
  this.manualTypeFilterCtrl.setValue(type); 
  this.fetchMakes();
}

}
